/*
 * @Description: 新增/编辑试用期员工绩效考核
 * @Author: 杨志航
 * @Date: 2026-02-12 09:56:51
 */
import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  Select,
  message,
  DatePicker,
  Radio,
  Button,
  Row,
  Col,
  Modal,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { allTrim, filterParams } from '@/utils'
import { jobTypeList } from '@/utils/constant'
import moment from 'moment'

const FormItem = Form.Item
const Option = Select.Option
const dateFormat = 'YYYY-MM-DD'

const AddProbation = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue, getFieldValue } = props.form
  const { setAddVisible, getList, bizno, editData } = props
  const [saveLoading, setSaveLoading] = useState(false)
  const [companyList, setCompanyList] = useState([])
  const [groupList, setGroupList] = useState([])
  const [departmentList, setDepartmentList] = useState([])
  const [departmentCampus, setDepartmentCampus] = useState([])
  const [projectList, setProjectList] = useState([])
  const [jobType, setJobType] = useState('')
  const [projectId, setProjectId] = useState('')
  const [saleTplList, setSaleTplList] = useState([])
  const [detail, setDetail] = useState({})
  const [assMethod, setAssMethod] = useState('')

  useEffect(() => {
    getSearchData()
    if (editData.id) {
      const { 
        id, bizno, groupId, companyId, departmentId, name, jobPostName, jobType, projectId, 
        joiningDate, probationaryLevel, regularLevel, mobile, isManager, auditDepartment, 
        assessmentMethod, tId, jobPostFileInfo, jobPostFileName 
      } = editData
      setDetail({
        id,
        fileInfo: jobPostFileInfo,
        fileName: jobPostFileName,
      })
      setJobType(jobType)
      setAssMethod(assessmentMethod)
      getGroupList(companyId, groupId, departmentId)
      setFieldsValue({
        bizno,
        name,
        joiningDate: moment(joiningDate),
        companyId,
        jobPostName,
        jobType,
        probationaryLevel,
        regularLevel,
        mobile,
        isManager,
        auditDepartment,
        assessmentMethod,
      })
      if (jobType !== 3) {
        if (projectId) {
          setFieldsValue({
            projectId: projectId.split(',').map(item => Number(item))
          })
          setProjectId(projectId)
          api.getAchSaleTplList({
            projectId
          }).then(data => {
            setSaleTplList(data.list)
            if (assessmentMethod === 2) {
              setFieldsValue({
                tId,
              })
            }
          }).catch(err => console.log(err))
        }
      }
    } else if (bizno) {
      setFieldsValue({
        bizno
      })
      getDetail(bizno)
    }
  }, [])

  const getDetail = bizno => { 
    api.getStaffRecruitmentList({ 
      bizno 
    }).then(data => {
      const { list } = data
      if (list.length === 0) {
        message.error('招聘业务编号不存在，请重新输入')
        return
      }
      const { companyId, groupId, departmentId, name, jobType, projectId } = list[0]
      setDetail(list[0])
      setJobType(jobType)
      getGroupList(companyId, groupId, departmentId)
      setFieldsValue({
        companyId,
        jobPostName: name,
        jobType,
      })
      if (jobType === 3) {
        setFieldsValue({
          assessmentMethod: 1,
        })
      } else {
        if (projectId) {
          setFieldsValue({
            projectId: projectId.split(',').map(item => Number(item))
          })
          getSaleTplList(projectId)
        } else {
          setFieldsValue({
            assessmentMethod: 1,
          })
        }
      }
    })
  }

  const getSearchData = () => {
    Promise.all([
      api.getsysProjectChilds({ pid: 0 }),
      api.getSelectCompanyList({ limit: global.paramsLimit }),
    ]).then(data => {
      setProjectList(data[0])
      setCompanyList(data[1].list)
    }).catch(err => console.log(err))
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  // 保存招聘
  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        if (editData.id) {
          vals.id = editData.id
        }
        vals = filterParams(vals)
        vals.joiningDate = vals.joiningDate.format(dateFormat)
        if (vals.projectId) {
          vals.projectId = vals.projectId.join(',')
        }
        setSaveLoading(true)
        api.setAchProbationReview(vals).then(() => {
          setSaveLoading(false)
          setAddVisible(false)
          message.success(editData.id ? '编辑成功' : '添加成功')
          getList()
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  //日期限制
  const disabledDate = (current) => {
    return current && current < moment().subtract(1, "day")
  }

  const onPreviewFile = () => {
    const id = getFieldValue('tId')
    if (!id) {
      message.warning('请选择等级销售模板')
      return
    }
    const data = saleTplList.find(item => item.id == id)
    window.open(data.fileInfo.url, '_blank')
  }

  const changeAssMethod = evt => {
    const { value } = evt.target
    setAssMethod(value)
    if (value === 2 && saleTplList.length === 0) {
      Modal.confirm({
        title: '提示',
        content: '请联系内控部董清华添加该项目的等级销售模板',
      })
    }
  }

  const onSelectCompany = companyId => {
    getGroupList(companyId, undefined, undefined)
  }

  const getGroupList = (companyId, groupId, departmentId) => {
    api.getGroupListByCompanyId({ 
      companyId,
    }).then(res => {
      setGroupList(res.groupList)
      setDepartmentCampus(res.departmentList)
      const list = res.departmentList.filter(item => item.groupId === groupId)
      setDepartmentList(list)
      setFieldsValue({
        groupId,
        departmentId,
      })
    }).catch(err => console.log(err))
  }

  const onSelectGroup = groupId => {
    const list = departmentCampus.filter(item => item.groupId === groupId)
    setDepartmentList(list)
    setFieldsValue({
      departmentId: undefined,
    })
  }

  const getSaleTplList = projectId => {
    setProjectId(projectId)
    if (projectId === '') {
      setFieldsValue({
        assessmentMethod: 1,
      })
      setAssMethod(1)
    } else {
      api.getAchSaleTplList({
        projectId
      }).then(data => {
        setSaleTplList(data.list)
      }).catch(err => console.log(err))
    }
  }

  const onSelectJobType = id => {
    setJobType(id)
    if (id === 3) {
      setFieldsValue({
        assessmentMethod: 1,
      })
      setAssMethod(1)
    }
  }

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="招聘业务编号">
          {getFieldDecorator('bizno', {
            rules: [{ required: true, message: '请输入招聘业务编号' }]
          })(
            <Input 
              placeholder="请输入招聘业务编号" 
              disabled={!!bizno && !!detail.id}
              onBlur={evt => getDetail(evt.target.value.trim())}
            />
          )}
        </FormItem>
        <FormItem label="员工姓名">
          {getFieldDecorator('name', {
            rules: [{ required: true, message: '请输入员工姓名' }]
          })(
            <Input placeholder="请输入员工姓名" />
          )}
        </FormItem>
        <FormItem label="预计入职日期">
          {getFieldDecorator('joiningDate', {
            rules: [{ required: true, message: '请选择预计入职日期' }]
          })(
            <DatePicker placeholder="请选择预计入职日期" disabledDate={disabledDate} style={{ width: '100%'}}/>
          )}
        </FormItem>
        <FormItem label="入职主体">
          {getFieldDecorator('companyId', {
            rules: [{ required: true, message: '请选择入职主体' }]
          })(
            <Select
              placeholder="请选择"
              showSearch
              optionFilterProp="children"
              onSelect={onSelectCompany}
            >
              {companyList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>)}
        </FormItem>
        <FormItem label="入职事业群">
          {getFieldDecorator('groupId', {
            rules: [{ required: true, message: '请选择入职事业群' }]
          })(
            <Select
              placeholder="请选择"
              showSearch
              optionFilterProp="children"
              onSelect={onSelectGroup}
            >
              {groupList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>)}
        </FormItem>
        <FormItem label="入职部门">
          {getFieldDecorator('departmentId', {
            rules: [{ required: true, message: '请选择入职部门' }]
          })(
            <Select
              placeholder="请选择"
              showSearch
              optionFilterProp="children"
            >
              {departmentList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>)}
        </FormItem>
        <FormItem label="岗位名称">
          {getFieldDecorator('jobPostName', {
            rules: [{ required: true, message: '请输入岗位名称' }]
          })(
            <Input placeholder="请输入岗位名称" />
          )}
        </FormItem>
        <FormItem label="岗位类别">
          {getFieldDecorator('jobType', {
            rules: [{ required: true, message: '请选择岗位类别' }]
          })((
            <Select
              placeholder="请选择" 
              onSelect={onSelectJobType}
            >
              {jobTypeList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>))}
        </FormItem>
        {jobType !== 3 && (
          <FormItem label="入职项目">
            {getFieldDecorator('projectId')(
              <Select 
                mode="multiple"
                placeholder="请选择"
                showSearch
                optionFilterProp="children"
                onChange={ids => getSaleTplList(ids.join(','))}
              >
                {projectList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
              </Select>
            )}
          </FormItem>
        )}
        <FormItem label="试用期级别">
          {getFieldDecorator('probationaryLevel', {
            rules: [{ required: true, message: '请输入试用期级别' }]
          })(
            <Input placeholder="请输入试用期级别" />
          )}
        </FormItem>
        <FormItem label="转正级别">
          {getFieldDecorator('regularLevel', {
            rules: [{ required: true, message: '请输入转正级别' }]
          })(
            <Input placeholder="请输入转正级别" />
          )}
        </FormItem>
        <FormItem label="手机号码">
          {getFieldDecorator('mobile', {
            rules: [
              { required: true, message: '请输入手机号码' },
              { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确' }
            ],
          })(
            <Input placeholder="请输入手机号码" maxLength={11} />
          )}
        </FormItem>
        <FormItem label="是否管理">
          {getFieldDecorator('isManager', {
            rules: [{ required: true, message: '请选择是否管理' }]
          })(
            <Radio.Group>
              <Radio value={1}>是</Radio>
              <Radio value={2}>否</Radio>
            </Radio.Group>)}
        </FormItem>
        <FormItem label="审核部门">
          {getFieldDecorator('auditDepartment', {
            rules: [{ required: true, message: '请选择审核部门' }]
          })(
            <Radio.Group>
              <Radio value={1}>内控部</Radio>
              <Radio value={2}>绩效部</Radio>
            </Radio.Group>)}
        </FormItem>
        <FormItem label="考核方式">
          {getFieldDecorator('assessmentMethod', {
            rules: [{ required: true, message: '请选择考核方式' }]
          })(
            <Radio.Group onChange={changeAssMethod} disabled={jobType === 3 || projectId === ''}>
              <Radio value={1}>试用期考核表</Radio>
              <Radio value={2}>等级销售模版</Radio>
            </Radio.Group>)}
        </FormItem>
        {assMethod === 2 && (
          <FormItem label="等级销售模板">
            <Row gutter={8}>
              <Col span={16}>
                {getFieldDecorator('tId', {
                  rules: [{ required: true, message: '请选择等级销售模板' }]
                })(
                  <Select 
                    placeholder="请选择"
                    showSearch
                    optionFilterProp="children"
                  >
                    {saleTplList.map(item => <Option key={item.id} value={item.id}>{item.fileName}</Option>)}
                  </Select>
                )}
              </Col>
              <Col span={8}>
                <Button type="primary" onClick={onPreviewFile}>等级销售模板预览</Button>
              </Col>
            </Row>
          </FormItem>
        )}
        <FormItem label="当前岗位说明书">
          <a href={detail.fileInfo?.url} target="_blank">{detail.fileName}</a>
        </FormItem>
        <BtnGroup onCancel={() => setAddVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  );
}

export default Form.create()(AddProbation)
